import React from 'react';

/** Vertical form field: label above, control, optional helper text below. */
export default function FormField({ label, required = false, hint, children, className = '' }) {
    return (
        <div className={`flex flex-col gap-1.5 ${className}`}>
            {label && (
                <span className="text-[13px] font-medium text-surface-700">
                    {label}
                    {required && <span className="ml-0.5 text-danger-fg">*</span>}
                </span>
            )}
            {children}
            {hint && <span className="text-xs text-surface-500">{hint}</span>}
        </div>
    );
}
